// Reads consented GA4 identifiers without waiting for analytics or affecting checkout.
const get_questad_checkout_tracking = () => {

    try {
        let analyticsStorage = false;
        let dataLayer = window?.dataLayer || [];

        dataLayer.forEach(entry => {
            if (entry?.[0] == 'consent' && entry?.[2]?.analytics_storage == 'granted') analyticsStorage = true;
        });

        if (!analyticsStorage) return false;

        let cookies = document.cookie.split(';');
        let clientId = false;
        let sessionId = false;

        cookies.forEach(cookie => {
            let item = cookie.split('=');
            let name = item?.[0]?.trim();
            let value = item?.slice(1)?.join('=');

            if (name == '_ga' && value) {
                let parts = value.split('.');
                if (parts?.length >= 4) clientId = parts[2] + '.' + parts[3];
            }

            if (name?.includes('_ga_') && value) {
                let parts = value.split('.');
                if (parts?.length >= 3) sessionId = parts[2];
            }
        });

        if (!clientId) return false;

        return {
            consent: {analytics_storage: true},
            clientId: clientId,
            sessionId: sessionId || false
        };
    }
    catch(error) {
        return false;
    }
};

export {get_questad_checkout_tracking};
